import * as constants from './constants';
import * as slice from './slice';
import sagas from './saga';

const giftCardService = { constants, slice, sagas };

export default giftCardService; 